import FaxUtils from "./FileUtils/faxUtils";
import FileDownloadUtils from "./FileUtils/fileDownloadUtils";
import ImageUtils from "./FileUtils/imageUtils";
import PdfUtils from "./FileUtils/pdfUtils";
import TiffUtils from "./FileUtils/tiffUtils";

const FileUtils = {
  printAll: ImageUtils.printAll,
  downloadFile: FileDownloadUtils.downloadFile,
  downloadFileAsPDF: PdfUtils.downloadFileAsPDF,
  exportFileAsPDF: PdfUtils.exportFileAsPDF,
  exportAllFileAsTIF: TiffUtils.exportAllFileAsTIF,
  faxSend: FaxUtils.faxSend,
  sendFaxMessage: FaxUtils.sendFaxMessage,
  faxNewFiles: FaxUtils.faxNewFiles,
};

export default FileUtils;
